import { render, staticRenderFns } from "./Gd.vue?vue&type=template&id=5830a670&scoped=true"
import script from "./Gd.vue?vue&type=script&lang=js"
export * from "./Gd.vue?vue&type=script&lang=js"
import style0 from "./Gd.vue?vue&type=style&index=0&id=5830a670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830a670",
  null
  
)

export default component.exports